import { useAtom } from 'jotai';
import { useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { eventOnChangeDateInput } from '@/lib/v2/components/DateInput/DateInput';

import { atomFiltersRecurrentAction } from '@/modules/CampaignsModule/atoms/recurrentActionsAtom';

export const useInputDate = () => {
  const { t } = useTranslation();

  const [filtersRecurrentAction, setFiltersRecurrentAction] = useAtom(atomFiltersRecurrentAction);

  const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([
    filtersRecurrentAction?.startDate ?? null,
    filtersRecurrentAction?.endDate ?? null,
  ]);

  const datePlaceholder = useMemo(() => {
    return t('CAMPAIGN_ACTIONS_MAIN.FILTERS.DATE.creationDate');
  }, [t]);

  const handleOnClickDate: eventOnChangeDateInput = useCallback(
    (event) => {
      if (Array.isArray(event)) {
        setDateRange(event as [Date | null, Date | null]);
        if (event[0] && event[1]) {
          setFiltersRecurrentAction({
            ...filtersRecurrentAction,
            startDate: event[0],
            endDate: event[1],
          });
        }
      }
    },
    [filtersRecurrentAction, setFiltersRecurrentAction]
  );

  const resetDateRange = useCallback(() => {
    setDateRange([null, null]);
  }, []);

  return {
    state: {
      dateRange,
      datePlaceholder,
    },
    events: {
      handleOnClickDate,
      resetDateRange,
    },
  };
};
